"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customerEditableBomItemUpdateDtoSchema = exports.customerEditableBomItemWithStaticMetadataSchema = exports.customerEditableBomItemSchema = void 0;
const zod_1 = require("zod");
const zod_partial_1 = require("@cadstrom/sigma-engine-shared/dist/Utils/zod-partial");
const customer_facing_bom_item_1 = require("./customer-facing-bom-item");
const customer_read_only_bom_item_1 = require("./customer-read-only-bom-item");
const catalogue_item_1 = require("./catalogue-item");
exports.customerEditableBomItemSchema = customer_read_only_bom_item_1.customerReadOnlyBomItemSchema.extend({
    isCustomerReviewed: zod_1.z.boolean(),
    foundInCatalogue: catalogue_item_1.CatalogueNameSchema.nullable(),
    manufacturerNameMetadataSourceField: zod_1.z.string().nullable(),
    manufacturerPartNumberMetadataSourceField: zod_1.z.string().nullable(),
    isDnpMetadataSourceField: zod_1.z.string().nullable(),
    isPrefilledFromMetadata: zod_1.z.boolean(),
    uploadedDatasheetFileId: zod_1.z.string().nullable(),
});
exports.customerEditableBomItemWithStaticMetadataSchema = exports.customerEditableBomItemSchema.extend({
    staticMetadata: customer_facing_bom_item_1.customerFacingBomItemStaticMetadataSchema,
});
exports.customerEditableBomItemUpdateDtoSchema = (0, zod_partial_1.partialWithoutDefaults)(exports.customerEditableBomItemSchema
    .omit({
    bomItemId: true,
    datasheetIsConfidential: true,
    datasheetStatus: true,
    datasheetStatusReason: true,
    datasheetNextAttemptAt: true,
    isPrefilledFromMetadata: true,
    manufacturerNameMetadataSourceField: true,
    manufacturerPartNumberMetadataSourceField: true,
    uploadedDatasheetFileId: true,
})
    .extend({ uploadedDatasheetFileId: zod_1.z.null() }));
//# sourceMappingURL=customer-editable-bom-item.js.map